<template>
  <div class="w-full max-w-full overflow-hidden">
    <div
      class="flex items-center p-8 bg-white rounded border border-gray-100 cursor-pointer transition-all hover:bg-gray-50"
      @click="onClickSelectMerchant">
      <van-icon name="shop" class="text-lg text-gray-800 mr-4" />
      <span class="flex-1 text-base font-medium text-gray-800 truncate mr-4">{{ selectedMerchant }}</span>
      <van-icon name="arrow-down" class="text-base text-gray transition-transform" />
    </div>

    <van-popup v-model:show="selectMerchantVisible" round position="bottom" class="rounded-t-lg w-full">
      <div class="text-center p-16 text-lg font-semibold text-gray-800 border-b border-gray-100">选择球馆</div>
      <van-picker :columns="merchants" @confirm="onSelectedMerchantConfirmed" @cancel="selectMerchantVisible = false"
        :title="'选择球馆'" show-toolbar />
    </van-popup>
  </div>
</template>

<script setup>
import { ref, onMounted } from 'vue';
import { Popup } from 'vant';
import apiUtil from "@/global/apiUtil";
const props = defineProps({});
const emit = defineEmits(['merchant-selected']);


const userId = ref('');
const merchants = ref([]);
const selectedMerchant = ref('选择球馆');
const selectedMerchantId = ref('');
const selectMerchantVisible = ref(false);

onMounted(async () => {
  userId.value = localStorage.getItem("userId");
  await getAllPlayerMerchants();
});

const onClickSelectMerchant = () => {
  console.info("onClickSelectMerchant");
  selectMerchantVisible.value = true;
};

const onSelectedMerchantConfirmed = (value) => {
  const selectedMerchantInfo = value.selectedOptions[0];
  selectMerchantVisible.value = false;
  console.log("选中的merchant信息:", selectedMerchantInfo); // 打印选中的merchant信息
  RaiseSelectedMerchantChanged(selectedMerchantInfo);
};

const RaiseSelectedMerchantChanged = (merchantInfo) => {
  const selectedMerchantInfo = merchantInfo;
  if (selectedMerchantInfo) {
    selectedMerchantId.value = selectedMerchantInfo.value;
    selectedMerchant.value = selectedMerchantInfo.text;
    emit('merchant-selected', { id: selectedMerchantId.value, name: selectedMerchant.value });
  }
};


const getAllPlayerMerchants = async () => {
  const queryObj = {};
  const result = await apiUtil.apiPost("Bowler/MyMerchants", queryObj);
  merchants.value = result.map(merchantInfo => ({ value: merchantInfo.id, text: merchantInfo.name }));
  if (merchants.value.length > 0) {
    RaiseSelectedMerchantChanged(merchants.value[0]);
  }
  console.debug(JSON.stringify(merchants.value));
};
</script>

<style>
/* 仅保留 Vant 组件的深度选择器样式 */
:deep(.van-picker) {
  background-color: white;
}

:deep(.van-picker__toolbar) {
  border-bottom: 1px solid #ebedf0;
}

:deep(.van-picker__title) {
  font-weight: 600;
  color: #2c3e50;
}

:deep(.van-picker__confirm) {
  color: #3498db;
}

:deep(.van-picker__cancel) {
  color: #7f8c8d;
}
</style>